import { render } from "./add_client_docs.vue?vue&type=template&id=ab62f762"
import script from "./add_client_docs.vue?vue&type=script&lang=js"
export * from "./add_client_docs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__